module.exports = __webpack_public_path__ + "static/media/xh.dd5a9430.png";